module.exports = __webpack_public_path__ + "img/passed-away-3-min.196bfaf8.png";